var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":false,"id":"app"}},[_c('v-content',[_c('BaseAlert',{attrs:{"showAlert":_vm.error,"messages":_vm.errors,"dismissAction":_vm.dismissError}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }